<template>
  <div class="mnp-in-start">
    <div class="mnp-in-start-content">
      <slot name="txtBefore"></slot>
      <slot v-if="portationTime_ === 'CONTRACT_END'" name="requirementsContractEnd"></slot>
      <slot v-if="portationTime_ === 'AS_SOON_AS_POSSIBLE'" name="requirementsASAP"></slot>
      <b-form>
        <b-form-group label="Zeitpunkt der Rufnummer mitnahme" label-class="visually-hidden">
          <b-form-radio-group
            v-model="portationTime_" required
            @input="$v.portationTime.$touch"
            :state="isValid('portationTime')"
            class="mnp-in-portation-time">
            <b-row>
              <b-col class="mnp-in-portation-time-radio">
                <b-form-radio
                  name="portationTimeCE"
                  value="CONTRACT_END"
                  class="mandatory"
                >
                  <slot name="portationTimeContractEnd">
                    <p>zum Ende der Vertragslaufzeit </p>
                  </slot>
                </b-form-radio>
              </b-col>
              <b-col class="mnp-in-portation-time-radio">
                <b-form-radio
                  name="portationTimeASAP"
                  value="AS_SOON_AS_POSSIBLE"
                  class="mandatory"
                >
                  <slot name="portationTimeASAP">
                    <p>vor Ende der Vertragslaufzeit </p>
                  </slot>
                </b-form-radio>
              </b-col>
            </b-row>
          </b-form-radio-group>
        </b-form-group>
        <b-form-group label="Zustimmen der Bedingungen" label-class="visually-hidden">
          <slot name="txtAfterRadio"></slot>
          <div class="input-consent">
            <b-form-checkbox-group
              :state="isValid('portationConsent')"
              v-model="portationConsent_"
              required>
              <b-form-checkbox
                v-model="portationConsent_" required
                @input="$v.portationConsent.$touch"
                :state="isValid('portationConsent')"
                id="mnp-in-portation-consent"
                class="mnp-in-checkbox mandatory"
              >
                <slot name="portationConsent">
                  <p>Hiermit bestätige ich, dass ich die Voraussetzungen gelesen und erfüllt habe.</p>
                </slot>
              </b-form-checkbox>
            </b-form-checkbox-group>
          </div>
        </b-form-group>
      </b-form>
      <slot name="txtAfter"></slot>
    </div>
    <Stepper
      @next="next()"
      :show-prev="false"
      :loading-next="loading"
      :disabled-next="$v.$invalid || loading"
      class="mnp-in-start-stepper"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>
import slotProxy from '@/mixins/slotProxy'
import syncProperty from '@/mixins/syncProperty'
import processSteps from '@/mixins/processSteps'
import Stepper from '@/components/generic/Stepper.vue'
import isValid from '@/mixins/isValid'
import { stepName as nextProcessStep } from './Data.vue'
import { mapActions, mapMutations } from 'vuex'
import { required, sameAs } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

export const stepName = 'mnpInStart'
export default {
  name: 'MnpInStart',
  data () {
    return {
      loading: false
    }
  },
  methods: {
    ...mapMutations('mnpIn', [
      'goToStep'
    ]),
    ...mapActions('mnpIn', [
      'storeAllStartData'
    ]),
    next () {
      this.loading = true
      this.storeAllStartData({
        portationTime: this.portationTime_,
        portationConsent: this.portationConsent_,
        nextStep: this.nextStep
      })
        .then(() => {
          this.loading = false
        }, () => {
          this.loading = false
        })
    }
  },
  components: {
    Stepper
  },
  mixins: [
    validationMixin,
    isValid,
    slotProxy(['Stepper']),
    processSteps(stepName, stepName, nextProcessStep), // prev = current, because first step
    syncProperty('portationTime', 'portationTime_'),
    syncProperty('portationConsent', 'portationConsent_')
  ],
  validations () {
    return {
      portationConsent: {
        required,
        sameAs: sameAs(() => true)
      },
      portationTime: {
        required
      }
    }
  }
}
</script>
